/* eslint-disable no-restricted-syntax -- this line was auto generated, hence fix the issue timely */
import React from "react";
import { useRemoteComponent } from "@bookingcom/remote-component";
import useRouteName from "hooks/useRouteName";
import { RouteName } from "app/routes";
import { Header as WebShellHeader } from "@bookingcom/web-shell";
import { BookingComLogoDarkBackgroundsMono } from "@bookingcom/bui-assets-react/brand";
import useUserAgent from "hooks/useUserAgent";
import styles from "./Header.module.css";
import useGlobalContext from "hooks/useGlobalContext";

const SMALL_HEADER_PAGE_LIST: RouteName[] = [
  "checkout-fare",
  "checkout-seat-selection",
  "checkout-sirf",
  "checkout-start",
  "checkout-ticket-type",
  "checkout-pax",
  "checkout-extras",
  "checkout-ryanair-confirmation",
  "checkout-payment",
  "checkout-collection", // FLIGHTS_WEB_PAYMENT_COLLECTION_NEW_PAGE
  "pb-checkout-payment",
  "messenger",
  "messenger-ended"
];

function HeaderFallback() {
  return <WebShellHeader logo={<BookingComLogoDarkBackgroundsMono />} />;
}

export default function Header() {
  const routeName = useRouteName();
  const { isMobile } = useUserAgent();
  const { isWebview } = useUserAgent();
  const { isFlightDetailsDesktopFullPage } = useGlobalContext();
  const remoteHeader = useRemoteComponent(
    {
      project: "web-shell",
      service: "header-mfe",
      path: "/TravellerHeader/Flights",
      type: "capla"
    },
    {
      fallbackComponent: HeaderFallback
    }
  );

  if (
    routeName === "not-available" ||
    (isWebview && routeName.includes("checkout-pax")) ||
    (isMobile && routeName.includes("flightdetails")) ||
    (isWebview && routeName === "additional-flights-terms") ||
    (isWebview && routeName === "home") ||
    (isWebview && routeName === "confirmation") ||
    (isWebview && routeName === "pb-order-details") ||
    (isWebview && routeName === "pb-flight-details") ||
    (isWebview && routeName === "pb-add-baggage") ||
    (isWebview && routeName === "pb-cancel-order") ||
    (isWebview && routeName === "pb-cancel-order") ||
    (isWebview && routeName === "pb-checkout-payment") ||
    (isWebview && routeName === "pb-checkout-confirmation") ||
    (isWebview && routeName === "additional-flights-terms")
  ) {
    return <></>;
  }

  const hideList = isFlightDetailsDesktopFullPage
    ? [
        ...SMALL_HEADER_PAGE_LIST,
        "flightdetails",
        /* start - flights_split_bounds_us */
        "flightdetails-outbound",
        "flightdetails-inbound"
        /* end - flights_split_bounds_us */
      ]
    : SMALL_HEADER_PAGE_LIST;

  const hideProductsBar = hideList.includes(routeName) || (isMobile && routeName === "searchresults");

  const { Component } = remoteHeader;
  return (
    <div className={hideProductsBar ? styles.root : undefined}>
      <Component />
    </div>
  );
}
